import { logWorkspace, requireUser } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import {
  ServiceUserStats,
  userStatsFromAgentStats,
} from '../../types/ServiceUser';

async function handleAgentStatus(event: Telecom.AgentStatusEvent) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:status:' + user?.name, event);

  user.available = event.available;
  user.availabilityState = event.availabilityState;
  user.capacity =
    event.availabilityState === 'On-A-Call' ||
    event.availabilityState === 'Wrapup-Time'
      ? 0
      : 1;

  if (!user.stats) {
    user.stats = {} as ServiceUserStats;
  }

  user.stats = userStatsFromAgentStats(event.stats);
}

export default handleAgentStatus;
